// extracted by mini-css-extract-plugin
export default {"backdrop":"backdrop__cxiXI","openBackdrop":"openBackdrop__zxv8r"};